export enum ERouterPath {
  login = '/login',
  logout = '/logout',
  passwordForgotten = '/password-forgotten',
  PasswordReset = '/password-reset/:code',
  dossier = '/dossier',
  selectFile = '/selecteer-dossier',
  personalDossiers = '/mijn-dossiers',
  allDossiers = '/alle-dossiers',
  newDossier = '/nieuw-dossier',
  updateDossier = '/update-dossier',
  /**
   * Possible query params:
   * ?add-to-dossier=<id>
   */
  newPerson = '/nieuw-persoon',
  updatePerson = '/persoon-wijzigen/:personId',
  /**
   * Possible query params:
   * ?add-to-dossier=<id> - will change the 'edit' buttons to 'add to dossier' buttons
   */
  listPersons = '/personen',
  /**
   * Possible query params:
   * ?add-to-dossier=<dossierId>
   * ?add-person=<personId>
   */
  addPersonToDossier = '/persoon-toevoegen-aan-dossier',
  reports = '/verslagen',
  reportsShared = '/verslagen/gedeeld',
  reportsClient = '/verslagen/client',
  reportsResponsible = '/verslagen/verantwoordelijk',
  accountSettings = '/instellingen',
  documents = '/materialen',
  documentsOfUser = '/materialen/:dossierMemberId',
  appointments = '/afspraken',
  chat = '/chat',
  chatConversation = '/chat/:groupId',
  tools = '/tools', // Deprecated?
  measurement = '/metingen',
  measurementNew = '/metingen/nieuw',
  measurementOverview = '/metingen/overzicht',
  measurementUnanswered = '/metingen/openstaande',
  notification = '/notification', // Changing this route will required you to update the route defined in the service worker
  /**
   * @deprecated use newPerson
   */
  newClient = '/nieuwe-client',
  manageDossier = '/alle-deelnemers',
  library = '/oefeningen',
  libraryItemsForRelation = '/oefeningen/:relationId',
  home = '/home',
  /**
   * @deprecated use dossier
   */
  base = '/',
}
